import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import type { ExperimentalOnboardingSpace } from '../__types__/ExperimentalSchema';
import { MediaType } from '../MediaType';
import type { ResolverContext } from '../resolver-context';

function getResponseCreateSpace(network: ResolverContext['network'], body: {}): Promise<Response> {
	return network.cfetch('/wiki/rest/create-dialog/1.0/space-blueprint/create-space?favorite=true', {
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
			Accept: MediaType.JSON,
		},
		body: JSON.stringify(body),
	});
}

function getResponseDraftId(
	network: ResolverContext['network'],
	spaceKey: string,
): Promise<Response> {
	return network.cfetch(`/wiki/rest/onboarding/1/draft/generate?spaceKey=${spaceKey}`, {
		method: 'GET',
	});
}

export const experimentalCreateSpecificSpace: ExperimentalMutations['experimentalCreateSpecificSpace'] =
	async (_, { spaceName, spaceKey, spaceBlueprintId, hasDraft }, { network }) => {
		const body = {
			context: {
				ContentPageTitle: spaceName,
				members: '',
			},
			name: spaceName,
			spaceKey,
			spaceBlueprintId,
			description: '',
		};
		try {
			const createSpaceRes = await getResponseCreateSpace(network, body);
			const createSpaceData: ExperimentalOnboardingSpace = await createSpaceRes.json();
			let draftIdData;
			if (hasDraft) {
				const draftIdRes = await getResponseDraftId(network, spaceKey);
				draftIdData = await draftIdRes.json();
			}
			return !createSpaceData || Object.keys(createSpaceData).length === 0
				? createSpaceData
				: { ...createSpaceData, draftId: draftIdData };
		} catch (e) {
			throw new Error(`/space-blueprint/create-space ${e.message}`);
		}
	};
